export default "__VITE_ASSET__8YjvQXnC__"